export default {"src":"/_next/static/media/fire-own.efe23846.svg","height":100,"width":100};